import React from 'react';
import classNames from 'classnames';
import ChirpPropShapes from 'javascripts/shared/chirp_prop_shapes';
import PropTypes from 'prop-types';

import { breakpoints } from 'javascripts/shared/utils/breakpoint_utils';
import { bubEvents } from 'shared/events/bub_events';

import { useMediaQuery } from 'react-responsive';

import styles from 'stylesheets/components/book_card/author_byline.module';

export function AuthorByline({ audiobook, disableLinks, trackingCategory, trackingType, trackingProperties, useSmallText }) {
  const isMobile = useMediaQuery({ maxWidth: breakpoints.lg });

  function trackClick(slug) {
    if (trackingCategory) {
      const props = {
        ...trackingProperties,
        label: `Author`,
        value: slug,
      };
      if (trackingType) {
        props.type = trackingType;
      }
      bubEvents.track(trackingCategory, 'Clicked link', props);
    }
  }

  function renderAuthorList() {
    // Mobile uses string comma separated author list
    if (disableLinks || isMobile) {
      return _.join(
        audiobook.allAuthors.map(author => author.name),
        ', ',
      );
    }

    // Desktop allows list of comma separated Author page links by name
    return audiobook.allAuthors.map((author, idx) => (
      <a key={author.slug} href={author.url} onClick={() => trackClick(author.slug)}>
        {idx > 0 ? ', ' : ''}
        {author.name}
      </a>
    ));
  }

  if (_.isEmpty(audiobook.allAuthors)) {
    return <h4 className={styles.byline} />;
  }

  return <h4 className={classNames(styles.byline, { [styles.small]: useSmallText })}>by {renderAuthorList()}</h4>;
}

AuthorByline.propTypes = {
  audiobook: ChirpPropShapes.audiobook.isRequired,
  disableLinks: PropTypes.bool,
  trackingCategory: PropTypes.string,
  trackingType: PropTypes.string,
  trackingProperties: PropTypes.object,
  useSmallText: PropTypes.bool,
};

AuthorByline.defaultProps = {
  disableLinks: false,
  trackingProperties: {},
  useSmallText: false,
};
